export const atofflineDeData = `
  <div class="page-title">Häufig gestellte Fragen zum Trade-In-Programm (FAQ)</div>
  </div>
  <div class="page-text-container">
    <div class="paragraph">
      <div class="title">Wer kann am Trade-In-Programm teilnehmen?</div>
      <div class="text-box">
        <div class="text">
        Der Trade-In-Service steht ausschließlich Personen ab 18 Jahren zur Verfügung, die ihren rechtmäßigen Wohnsitz in einem Mitgliedstaat der Europäischen Union haben, mit Ausnahme der Kanarischen Inseln, der Balearen, Ceuta und Melilla.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Was sollte ich tun, bevor ich mein Altgerät einsende?</div>
      <div class="text-box">
        <div class="text">
        Bevor Sie Ihr Gerät einsenden:
        </div>
        <div class="text">
        - Löschen Sie alle persönlichen Daten und entfernen Sie alle PINs, Passwörter oder Displaysperren.
        </div>
        <div class="text">
        - Führen Sie einen vollständigen Werksreset durch.
        </div>
        <div class="text">
        - Bei iPhone: Trennen Sie Ihr iCloud-Konto, indem Sie „Mein iPhone suchen“ deaktivieren.
        </div>
        <div class="text">
        - Bei Android: Entfernen Sie Ihr Google-Konto (Einstellungen > Konten > Google > Konto entfernen).
        </div>
        <div class="text">
        So stellen Sie sicher, dass Ihr Gerät nicht mehr mit Ihrem Konto verknüpft ist und Ihre persönlichen Daten geschützt bleiben.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Wie kann ich mein Altgerät versenden?</div>
      <div class="text-box">
        <div class="text">
        Verpackung: Verwenden Sie eine stabile, undurchsichtige Schachtel (nicht transparent) und fügen Sie einen inneren Schutz (z. B. Luftpolsterfolie) hinzu, um Transportschäden zu vermeiden.
        </div>
        <div class="text">
        Verpackungsmaterialien: Wenn Sie keine geeigneten Verpackungsmaterialien haben, können Sie diese am Abgabepunkt anfordern, wenn Sie Ihr Paket abgeben.
        </div>
        <div class="text">
        Dokumentation: Drucken Sie die Ehrlichkeitserklärung aus, füllen Sie sie aus, unterschreiben Sie sie und legen Sie sie vor dem Verschließen in das Paket.
        </div>
        <div class="text">
        Sicheres Verschließen: Stellen Sie sicher, dass das Paket gut verschlossen ist, und befestigen Sie das kostenlose Versandetikett gut sichtbar außen.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Welche Arten von Geräten werden nicht akzeptiert?</div>
      <div class="text-box">
        <div class="text">
        Wir akzeptieren keine Geräte, die:
        </div>
        <div class="text">
        - mit einem SIM-Lock versehen sind;
        </div>
        <div class="text">
        - sich nicht einschalten oder laden lassen;
        </div>
        <div class="text">
        - keine Verbindung über Bluetooth oder WLAN herstellen können;
        </div>
        <div class="text">
        - einen Defekt interner Komponenten oder des Mainboards aufweisen;
        </div>
        <div class="text">
        - keine Fotos aufnehmen oder Videos ordnungsgemäß aufzeichnen können;
        </div>
        <div class="text">
        - über gesprungene Linsen oder schwere strukturelle Schäden verfügen;
        </div>
        <div class="text">
        - defekte Tasten oder Stabilisierungsprobleme aufweisen;
        </div>
        <div class="text">
        - Flüssigkeitsschäden erlitten haben oder repariert/demontiert wurden;
        </div>
        <div class="text">
        - noch mit iCloud, Google oder einem Benutzerkonto verknüpft sind;
        </div>
        <div class="text">
        - Fälschungen oder Replikate sind;
        </div>
        <div class="text">
        - stark beschädigt sind.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Muss ich Zubehör (Ladegerät, Kabel usw.) mitsenden?</div>
      <div class="text-box">
        <div class="text">
        Das ist nicht verpflichtend, wird jedoch empfohlen. Das Beilegen von Zubehör unterstützt Nachhaltigkeit und die Wiederverwendung der Geräte.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Muss ich Kopfhörer mitsenden?</div>
      <div class="text-box">
        <div class="text">
        Nein. Aus hygienischen Gründen werden Kopfhörer entsorgt und nicht in die Bewertung einbezogen.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Muss ich die Kaufrechnung mitsenden?</div>
      <div class="text-box">
        <div class="text">
        Nein, die Rechnung wird weder für die Bewertung noch für die Auszahlung benötigt. Sie können sie für Ihre eigenen Unterlagen aufbewahren.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Wie wird mein Altgerät bewertet?</div>
      <div class="text-box">
        <div class="text">
        Wir verwenden zertifizierte Diagnosesoftware und führen eine manuelle Prüfung in unserem Bewertungszentrum durch, um den Zustand Ihres Geräts zu bestimmen. Alle Bewertungs- und Datenverarbeitungsverfahren erfolgen in Übereinstimmung mit der Datenschutz-Grundverordnung (DSGVO – EU 2016/679) und gewährleisten die Sicherheit und Vertraulichkeit Ihrer Daten.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Was passiert, wenn der von mir angegebene Zustand nicht mit eurer Bewertung übereinstimmt?</div>
      <div class="text-box">
        <div class="text">
        Wenn Abweichungen zwischen dem angegebenen und dem tatsächlichen Zustand festgestellt werden, senden wir Ihnen eine E-Mail mit:
        </div>
        <div class="text">
        - einem aktualisierten Angebot basierend auf der tatsächlichen Inspektion;
        </div>
        <div class="text">
        - dem Diagnosebericht und den Gründen für die Abweichung.
        </div>
        <div class="text">
        Sie können das Angebot annehmen oder ablehnen:
        </div>
        <div class="text">
        - Wenn Sie annehmen, wird der Trade-In-Vorgang abgeschlossen, und Sie erhalten die Zahlung innerhalb von 3 Werktagen auf Ihr Bankkonto.
        </div>
        <div class="text">
        - Wenn Sie ablehnen, hängt der Rücksendeprozess von Ihrem Standort ab:
        </div>
        <div class="text">
          - Für alle Kunden fällt eine Rücksendegebühr von bis zu maximal 22 € (inkl. MwSt.) an.
        </div>
        <div class="text">
          - Die Gebühr ist innerhalb von fünf (5) Kalendertagen nach Erhalt der Zahlungsaufforderung unter Verwendung des von Danghuan bereitgestellten offiziellen vorausbezahlten Rücksendeetiketts zu entrichten.
        </div>
        <div class="text">
          - Die Zahlungsinformationen werden auf Anfrage bereitgestellt oder sind in der Zahlungslink-E-Mail enthalten.
        </div>
        <div class="text">
          - Nach Bestätigung des Zahlungseingangs überprüft Danghuan die Transaktion innerhalb von fünf (5) Werktagen und organisiert die Rücksendung an die ursprüngliche Versandadresse. Der Kunde wird per E-Mail benachrichtigt, sobald die Sendung versandt wurde, einschließlich der entsprechenden Sendungsverfolgungsnummer.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Was passiert, wenn ich nicht auf das aktualisierte Angebot reagiere?</div>
      <div class="text-box">
        <div class="text">
        Erfolgt innerhalb von fünf (5) Kalendertagen ab dem Benachrichtigungsdatum keine Rückmeldung, gilt das überarbeitete Angebot automatisch als angenommen, ohne weitere Mitteilung, Erinnerung oder zusätzliche Kommunikation durch Danghuan.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Was geschieht mit meinen personenbezogenen Daten?</div>
      <div class="text-box">
        <div class="text">
        Sie müssen alle Daten löschen, bevor Sie Ihr Altgerät einsenden. Wenn wir verbleibende Daten feststellen, pausieren wir den Prozess und kontaktieren Sie, um diese zu entfernen. Wir erfüllen vollständig die Anforderungen der DSGVO (Verordnung EU 2016/679).
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Wer trägt die Versandkosten?</div>
      <div class="text-box">
        <div class="text">
        Der Erstversand ist immer kostenlos.
        </div>
        <div class="text">
        Wenn Sie das aktualisierte Angebot ablehnen:
        </div>
        <div class="text">
        - Für alle Kunden fällt eine Rücksendegebühr von bis zu maximal 22 € (inkl. MwSt.) an.
        </div>
        <div class="text">
        - Die Gebühr ist innerhalb von fünf (5) Kalendertagen nach Erhalt der Zahlungsaufforderung unter Verwendung des von Danghuan bereitgestellten offiziellen vorausbezahlten Rücksendeetiketts zu entrichten.
        </div>
        <div class="text">
        - Die Zahlungsinformationen werden auf Anfrage bereitgestellt oder sind in der Zahlungslink-E-Mail enthalten.
        </div>
        <div class="text">
        - Sobald die Zahlung bestätigt wurde, überprüft Danghuan die Transaktion innerhalb von 5 Werktagen und organisiert den Rückversand an Ihre ursprüngliche Adresse. Sie werden per E-Mail informiert, sobald das Paket versandt wurde, einschließlich der entsprechenden Sendungsverfolgungsinformationen.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Was passiert, wenn mein Paket während des Versands verloren geht?</div>
      <div class="text-box">
        <div class="text">
        Wenn Ihr Gerät während des Transports verloren geht, unterstützt Danghuan Europe S.L. Sie beim offiziellen Reklamationsprozess des Kurierdienstes.
        </div>
        <div class="text">
        Eine Sendung gilt als verloren, wenn sie innerhalb von 15 Kalendertagen nach Übergabe an den Kurier nicht nachverfolgt, bestätigt oder von Danghuan erhalten wurde.
        </div>
        <div class="text">
        - Sie müssen das autorisierte, vorfrankierte Versandetikett von Danghuan verwenden; jede andere Versandmethode schließt den Verlustschutz aus.
        </div>
        <div class="text">
        - Reklamationen bei UPS müssen innerhalb von 60 Tagen nach Erstellung des Etiketts eingereicht werden.
        </div>
        <div class="text">
        - Bei CORREOS (Spanien)-Sendungen sollten Reklamationen so früh wie möglich, idealerweise innerhalb von 15 Tagen und spätestens innerhalb eines Jahres nach Versanddatum eingereicht werden.
        </div>
        <div class="text">
        - Danghuan unterstützt bei der Untersuchung des Kurierdienstes, die in der Regel 30–60 Tage dauert.
        </div>
        <div class="text">
        Wenn der Verlust im Danghuan-Logistiksystem bestätigt wird und das autorisierte Etikett verwendet wurde, übersteigt die Entschädigung nicht den endgültig bewerteten Trade-In-Wert des Geräts.
        </div>
        <div class="text">
        Genehmigte Zahlungen werden direkt auf das bei der Registrierung angegebene IBAN überwiesen.
        </div>
        <div class="text">
        Hinweis: Jede Entschädigung hängt von der Richtlinie des jeweiligen Kurierdienstes ab.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Wann erhalte ich die Zahlung?</div>
      <div class="text-box">
        <div class="text">
        Nach Annahme des endgültigen Angebots erfolgt die Auszahlung per Banküberweisung innerhalb von 3 Werktagen. Bitte stellen Sie sicher, dass Ihre IBAN und Ihre Personalausweisnummer korrekt sind und mit dem Kontoinhaber übereinstimmen.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Ist die Angabe meiner Personalausweisnummer verpflichtend?</div>
      <div class="text-box">
        <div class="text">
        Ja. Um die Zahlung zu verarbeiten, müssen Sie eine gültige Personalausweisnummer angeben, ohne Leerzeichen oder Sonderzeichen, die mit dem Inhaber des IBAN-Kontos übereinstimmt.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Kann ich meine Trade-In-Transaktion stornieren?</div>
      <div class="text-box">
        <div class="text">
        Ja, sofern Ihr Altgerät noch nicht bezahlt wurde. Bitte kontaktieren Sie uns so schnell wie möglich unter vivo-at@danghuan.eu. Wenn Sie Ihr Gerät bereits versendet haben, kontaktieren Sie uns bitte innerhalb von 48 Stunden; andernfalls wird der Recyclingprozess wie vorgesehen fortgesetzt.
        </div>
      </div>
    </div>

    <div class="paragraph">
      <div class="title">Wann erhalte ich meinen Bonus?</div>
      <div class="text-box">
        <div class="text">
        Der Bonus wird zusammen mit dem Trade-In-Betrag ausgezahlt, sobald sowohl die Bestellung des neuen vivo Geräts als auch die Trade-In-Transaktion erfolgreich abgeschlossen sind. Der Bonus gilt ausschließlich für Bestellungen neuer vivo Geräte.
        </div>
      </div>
    </div>
  </div>
`;